import { HardHat, Users, Building2, Clock, ClipboardList, TrendingUp } from "lucide-react";

export const CONTACT = {
  phone: "0414 737 340",
  phoneHref: "tel:+61414737340",
  email: "info@formcoreconstructions.com.au",
  emailHref: "mailto:info@formcoreconstructions.com.au",
  address1: "Unit 7B, 4 Brunker Road",
  address2: "Chullora NSW 2190",
  website: "formcoreconstructions.com.au",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Workforce", to: "/workforce" },
  { label: "Safety & Compliance", to: "/safety-compliance" },
  { label: "Why Formcore", to: "/why-formcore" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2400&auto=format&fit=crop",
  intro: "https://images.unsplash.com/photo-1632862378069-4ad0348cea4f?q=80&w=1600&auto=format&fit=crop",
  civil: "https://images.unsplash.com/photo-1536895058696-a69b1c7ba34f?q=80&w=1600&auto=format&fit=crop",
  workforce: "https://images.unsplash.com/photo-1626885930974-4b69aa21bbf9?q=80&w=1600&auto=format&fit=crop",
  bridge: "https://images.pexels.com/photos/38933029/pexels-photo-38933029.jpeg?auto=compress&cs=tinysrgb&w=1600",
  safety: "https://images.pexels.com/photos/8961034/pexels-photo-8961034.jpeg?auto=compress&cs=tinysrgb&w=1600",
  steel: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2200&auto=format&fit=crop",
  engineer: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?q=80&w=1600&auto=format&fit=crop",
  plans: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1600&auto=format&fit=crop",
  site: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?q=80&w=1600&auto=format&fit=crop",
};

export const STATS = [
  { value: 150, suffix: "+", label: "Workforce in NSW", numeric: true },
  { value: 20, suffix: "+", label: "Years Management & Construction Experience", numeric: true },
  { value: "National", label: "Workforce Expansion", numeric: false },
  { value: "Safety First", label: "Commitment to Safe Work Practices", numeric: false },
  { value: "Client Focused", label: "Built Around Your Requirements", numeric: false },
];

export const SERVICES = [
  {
    icon: HardHat,
    title: "General Construction Labour",
    text: "Reliable personnel for a wide range of construction and site-support requirements.",
  },
  {
    icon: Users,
    title: "Skilled Construction Personnel",
    text: "Experienced personnel selected according to the specific skills and requirements of each project.",
  },
  {
    icon: Building2,
    title: "Project Workforce Solutions",
    text: "Scalable workforce solutions for projects requiring multiple personnel and ongoing workforce coordination.",
  },
  {
    icon: Clock,
    title: "Short-Term & Long-Term Labour Hire",
    text: "Flexible workforce arrangements designed to accommodate both immediate requirements and longer-term operational needs.",
  },
  {
    icon: ClipboardList,
    title: "Workforce Management",
    text: "Professional coordination and ongoing management designed to ensure personnel remain supported, compliant and aligned with client expectations.",
  },
  {
    icon: TrendingUp,
    title: "Workforce Scaling",
    text: "The ability to increase or reduce workforce requirements in response to project demands, timelines and operational requirements.",
  },
];

export const INDUSTRIES = [
  "Commercial Construction",
  "Residential Construction",
  "Civil Construction",
  "Infrastructure Projects",
  "Industrial Construction",
  "Demolition & Site Preparation",
  "Fit-out & Refurbishment",
  "General Construction Support",
  "Major Projects",
  "Maintenance & Project-Based Works",
];

export const WHY_POINTS = [
  {
    title: "Proven NSW Track Record",
    text: "Formcore has established a workforce of more than 150 personnel in NSW and is now leveraging this experience as it expands nationally.",
  },
  {
    title: "Construction Industry Experience",
    text: "Our management team brings more than 20 years of experience across construction, workforce management and labour hire.",
  },
  {
    title: "Tier 1 Experience",
    text: "Our management team has experience managing workforces operating in Tier 1 and major construction environments.",
  },
  {
    title: "Carefully Selected Workforce",
    text: "Personnel are selected with consideration to capability, experience, reliability and project requirements.",
  },
  {
    title: "Continuous Upskilling",
    text: "We invest in developing our workforce so our personnel can continue to meet the expectations of clients and evolving industry requirements.",
  },
  {
    title: "Professional Management",
    text: "Our clients deal with an experienced management team capable of understanding workforce, operational, safety and administrative requirements.",
  },
  {
    title: "Worker Support",
    text: "We recognise the importance of supporting workers socially, financially and logistically, helping create a more stable and engaged workforce.",
  },
  {
    title: "Scalable Solutions",
    text: "Our workforce model is designed to support changing project requirements and workforce volumes.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Formcore has consistently provided reliable personnel and responsive workforce support throughout our projects.",
    name: "Project Manager",
    company: "Commercial Builder, Sydney",
  },
  {
    quote: "The quality of personnel and the level of management support sets Formcore apart from other labour hire providers we have worked with.",
    name: "Site Manager",
    company: "Civil Contractor, NSW",
  },
  {
    quote: "Responsive, professional and safety-focused. Formcore understands the pressures of project delivery.",
    name: "Procurement Lead",
    company: "Tier 2 Contractor",
  },
];

export const CREDENTIALS = [
  { title: "Labour Hire Licensing", text: "Applicable state labour hire licensing and regulatory compliance." },
  { title: "Public Liability Insurance", text: "Current public liability coverage for workforce operations." },
  { title: "Workers Compensation", text: "Workers compensation coverage for all Formcore personnel." },
  { title: "Safety Documentation", text: "Safety management processes, SWMS and site compliance documentation." },
  { title: "Training & Competency", text: "Verified tickets, licences and competency records for personnel." },
  { title: "Industry Memberships", text: "Participation in relevant construction and workforce industry bodies." },
];

export const STATES = [
  { code: "NSW", status: "Established", note: "150+ personnel across New South Wales" },
  { code: "QLD", status: "Expanding", note: "Queensland operations underway" },
  { code: "VIC", status: "Expanding", note: "Victoria market entry" },
  { code: "ACT", status: "Expanding", note: "Australian Capital Territory" },
  { code: "AUS", status: "Nationwide", note: "National workforce partner strategy" },
];

export const MARQUEE_ITEMS = [
  "Commercial",
  "Civil",
  "Infrastructure",
  "Residential",
  "Industrial",
  "Major Projects",
  "Fit-Out",
  "Demolition",
];
